<div class="absolute inset-0">
  <ng-content />
</div>
